
import { Groupbutton, ModalContainer } from './styles';

import Layer from 'services/models/Layer';
import { getCookie } from 'services/utils/cookies';
import Coordinate from 'services/utils/Coordinate';

import OrangeMarker from './assets/orange-marker.svg';
import PinkMarker from './assets/pink-marker.svg';
import AlertConfirm from './components/AlertConfirm/index';

import AttributeTable from '../../../../AttributeTable';
import ButtonTooltip from '../../ButtonTooltip';

/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import { CustomModalSaveAsLayer } from 'views/MapView/components/CustomModalSaveAsLayer';


/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';
import CustomDraggable from 'components/ModalDraggable';
import Notice from 'components/Notice';
import { useFormik } from 'formik';
import L from 'leaflet';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 *
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 *
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState,useEffect, useCallback } from 'react';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import ReactDOM from 'react-dom';
import SliderColorPicker from 'views/MapView/components/SliderColorPicker';
import { useMap } from 'views/MapView/hooks';
import { useModule } from 'views/MapView/hooks';
import * as Yup from 'yup';


const Icon = (props) => (
<svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M11.585 2.83318C9.12346 1.29028 5.84041 1.59 3.69805 3.73237C1.23093 6.19949 1.2072 10.2086 3.6506 12.6994L8.19343 17.2422L8.85452 16.5811L9.39924 17.7207L8.20529 18.9147L2.82032 13.5297C-0.0856629 10.5763 -0.0619407 5.83179 2.86777 2.90208C5.79767 -0.0278185 10.5135 -0.0511584 13.4719 2.83206L11.585 2.83318Z" fill="#BEC7DC"/>
<path d="M13.0037 7.8396H12.3524C10.869 7.8396 9.66638 8.83491 9.66638 10.0625V12.5759V13.2822V13.4712C9.66638 13.8761 9.99452 14.204 10.3991 14.204H10.899L11.2283 17.9397C11.2283 18.4778 11.6458 18.9141 12.1607 18.9141H13.1966C13.7117 18.9141 14.1292 18.4778 14.1292 17.9397L14.4583 14.204H14.9578C15.3627 14.204 15.6906 13.8761 15.6906 13.4712V13.2822V12.5759V10.0625C15.6903 8.83491 14.4877 7.8396 13.0037 7.8396Z" fill="#BEC7DC"/>
<path d="M12.7186 7.54569C13.6177 7.54569 14.3466 6.81678 14.3466 5.91762C14.3466 5.01846 13.6177 4.28955 12.7186 4.28955C11.8194 4.28955 11.0905 5.01846 11.0905 5.91762C11.0905 6.81678 11.8194 7.54569 12.7186 7.54569Z" fill="#BEC7DC"/>
</svg>

);

const IconClose = (props) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      y1="-0.75"
      x2="12"
      y2="-0.75"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 9.92969 1.19043)"
      stroke="#ABABAB"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="12"
      y2="-0.75"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 1.44531 0.0766602)"
      stroke="#ABABAB"
      strokeWidth="1.5"
    />
  </svg>
);

const IconSave = (props) => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.6679 13.1729C6.34872 13.1729 6.04155 13.0464 5.81481 12.8196L0.990032 7.99483C0.518948 7.52347 0.518948 6.76002 0.990032 6.28893C1.4614 5.81785 2.22485 5.81785 2.69593 6.28893L6.59725 10.1902L14.7766 0.59627C15.2088 0.0900011 15.9698 0.0288466 16.4772 0.460837C16.984 0.893106 17.0446 1.6546 16.6126 2.16143L7.58577 12.749C7.3674 13.005 7.05214 13.1583 6.71565 13.1717C6.69973 13.1723 6.68381 13.1729 6.6679 13.1729Z"
      fill="#BEC7DC"
    />
  </svg>
);

const IconRemove = (props) => (
  <svg
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.82599 2.32058H4.20099V1.94558C4.20099 1.44978 4.60292 1.04785 5.09872 1.04785H7.64418C8.13998 1.04785 8.5419 1.44978 8.5419 1.94558V2.32058H8.9169H12.0987C12.2431 2.32058 12.3601 2.43759 12.3601 2.58194V3.85467C12.3601 3.99902 12.2431 4.11603 12.0987 4.11603H11.4624H11.0874V4.49103V13.4001C11.0874 13.8959 10.6854 14.2979 10.1896 14.2979H2.55327C2.05747 14.2979 1.65554 13.8959 1.65554 13.4001V4.49103V4.11603H1.28054H0.644176C0.499829 4.11603 0.382812 3.99902 0.382812 3.85467V2.58194C0.382812 2.4376 0.499829 2.32058 0.644176 2.32058H3.82599ZM4.46236 5.38876C3.9038 5.38876 3.45099 5.84156 3.45099 6.40012V11.491C3.45099 12.0496 3.9038 12.5024 4.46236 12.5024C5.02092 12.5024 5.47372 12.0496 5.47372 11.491V6.40012C5.47372 5.84156 5.02092 5.38876 4.46236 5.38876ZM8.28054 5.38876C7.72198 5.38876 7.26918 5.84156 7.26918 6.40012V11.491C7.26918 12.0496 7.72198 12.5024 8.28054 12.5024C8.8391 12.5024 9.2919 12.0496 9.2919 11.491V6.40012C9.2919 5.84156 8.8391 5.38876 8.28054 5.38876Z"
      stroke="#BEC7DC"
      strokeWidth="0.75"
    />
  </svg>
);

/**
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @param {*} props Resto
 * @returns Retorna uma tabela na parte inferior da tela com as feiçoes de acordo
 * com as camadas importadas e o local selecionado.
 */
export const IdentifyFeatureLocation = ({
  mapContext,
  isActive,
  setIsActive,
  ...props
}) => {
  const [latlngMarker, setLatLngMarker] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const { setBottomPanelIsOpen } = mapContext;

  const [x, setX] = useState(null);
  const [y, setY] = useState(null);
  const [limitAllowed, setLimitAllowed] = useState(null);
  const [err, setErr] = useState(null)
  const [searchingData, setSearchingData] = useState(false);
  const { activeModule, getElement } = useModule();

  const [openTable, setOpenTable] = useState(null);
  const [cursor, setCursor] = useState(null);
  const [addCursor, setAddCursor] = useState(false)

  const mapTool = getElement('CPN-MA-MAP');          
  const configInformationalMessage = {
    optionDontShowAlertAgain: mapTool?.configuracao.optionNotShowAgain !== false,
    aliasModule: activeModule.apelido,
    toolId: IdentifyFeatureLocation.properties.id,
    aliasIdentifierCookie: 'dontShowInformationMessage',
    expireDays: mapTool?.configuracao.daysToExpire,
  };
  const [foundData, setFoundData] = useState(null);

  const { map, layers, addLayer, setLoadingInMap } = useMap();

  const formik = useFormik({
    initialValues: {
      layerName: '',
      layerStyle: null,
    },
    validationSchema: Yup.object().shape({
      layerName: Yup.string().required('Campo obrigatório'),
    }),
    onSubmit: (values) => {
      saveAsLayer(values.layerName, values.layerStyle);
    },
  });
  const { resetForm } = formik;

  const handleDisableTool = useCallback(() => {
    setX(null);
    setY(null);
    setLatLngMarker(null);
    setIsActive(false);
    setShowModal(false);
    setLimitAllowed(null);
    setErr(null);
    setFoundData(null);
    setSearchingData(false);
    setAddCursor(false);
    setOpenTable(false)
  }, [setIsActive]);

  const saveAsLayer = useCallback(
    (layerName, layerStyle) => {
      let markerPoint = L.marker(latlngMarker);
      let markerPointGeoJSON = markerPoint.toGeoJSON();

      markerPointGeoJSON.properties.ID_GBA = 1;
      //formatar para dms graus minutos segundos
      const coordinates = [
        markerPointGeoJSON.geometry.coordinates[1],
        markerPointGeoJSON.geometry.coordinates[0],
      ];

      const dmsCoordinates = Coordinate.convertDDToDMS(coordinates);
      markerPointGeoJSON.properties['Latitude'] = dmsCoordinates[0];
      markerPointGeoJSON.properties['Longitude'] = dmsCoordinates[1];

      const customRender = L.canvas({ pane: 'mixedPane' });
      let options = {
        pane: 'mixedPane',
        renderer: customRender,
        style: layerStyle,
        pointToLayer: function (feature, latlng) {
          return L.circleMarker(latlng, {
            pane: 'mixedPane',
            ...layerStyle,
            renderer: customRender,
          });
        },
      };
      let geoJsonLayer = L.geoJSON(markerPointGeoJSON, options);

      let layerToAdd = new Layer(
        null,
        'criada',
        null,
        layerName,
        null,
        null,
        null,
        null,
        null
      );
      layerToAdd.setLeafletLayer(geoJsonLayer);
      layerToAdd.setLayerStyle(layerStyle);
      addLayer(layerToAdd);
      setSaveModalOpen(false);
      resetForm();

      // romove o marcador do mapa
      handleDisableTool();
    },
    [latlngMarker, addLayer, resetForm, handleDisableTool]
  );

  /**
   * Reseta formik para estado inicial e fecha modal
   */
  const handleCloseSaveModal = useCallback(() => {
    resetForm();
    setSaveModalOpen(false);
    setBottomPanelIsOpen(false);
    handleDisableTool();
  }, [handleDisableTool, resetForm, setBottomPanelIsOpen]);
  
  const success = (pos) => {    
    setX(parseFloat(pos.coords.latitude.toFixed(7)));
    setY(parseFloat(pos.coords.longitude.toFixed(7)));
    setLatLngMarker([parseFloat(pos.coords.latitude.toFixed(7)), parseFloat(pos.coords.longitude.toFixed(7))]);
    checkAllowedLimit(parseFloat(pos.coords.latitude.toFixed(7)), parseFloat(pos.coords.longitude.toFixed(7)));
  }
  const error = (err) => {
    setErr(err.message);
    setLatLngMarker(null);
    setLoadingInMap(false);
  }
  const getLocation = () => {
    navigator.geolocation.getCurrentPosition(success, error,{
    enableHighAccuracy: true,
  });
  }

  const checkAllowedLimit = (lat, lng) => {
    let allowedLimit;
    // URL de exemplo para fazer a solicitação ao serviço Nominatim
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`;

    // Fazendo a solicitação
    fetch(url)
      .then((response) => response.json())
      .then((data) => {        
        try {
          const state = (data.address.state).toLowerCase();
          if (state === "bahia") {
            allowedLimit = true;
          } else {
            allowedLimit = false;
            setLoadingInMap(false);
          }
          setLimitAllowed(allowedLimit);
        }
        catch (error) {            
            // this.Messages.requestFailed(error);   
            setLoadingInMap(false);
            setLimitAllowed(false);
        }        
      })      
      // eslint-disable-next-line no-console
      .catch((error) => console.log('Erro ao processar a solicitação:', error));
  }

  const getFromWms = async (wmsLayers, x, y, mapSize, bboxString) => {
    if (wmsLayers.length > 0) {
      let promises = [];
      let featuresInfo = {};
      wmsLayers.forEach((v) => {
        let layerNames = Object.keys(v.layers);
        featuresInfo = { ...featuresInfo, ...v.layers };
        let getFeatureInfoParams = {
          service: 'WMS',
          version: '1.1.1',
          request: 'GetFeatureInfo',
          layers: layerNames.join(','),
          styles: '',
          srs: 'EPSG:4326',
          bbox: bboxString,
          width: mapSize.x,
          height: mapSize.y,
          query_layers: layerNames.join(','),
          info_format: 'application/json',
          tiled: 'true',
          x,
          y,
          feature_count: 50,
        };

        promises.push(
          axios(v.baseUrl, {
            params: getFeatureInfoParams,
          })
            .then(({ data }) => ({
              data,
              raster: v.raster,
              id: v.raster ? layerNames[0] : null,
            }))
            .catch((e) => {
              return null;
            })
        );
      });
      return await Promise.all(promises).then((values) => {
        //Obtém os nomes das camadas sem o workspace, para se igualar a resposta
        let layerNames = Object.keys(featuresInfo).reduce(
          (ac, k) => ({ ...ac, [k.split(':')[1]]: k }),
          {}
        );
        values.forEach((result) => {
          if (result && result.data.features?.length > 0) {
            result.data.features.forEach((feature) => {
              let layerName = result.raster
                ? result.id.split(':')[1]
                : feature.id.split('.')[0];
              if (featuresInfo[layerNames[layerName]]) {
                let featureProperties = feature.properties;
                let featureBbox = featureProperties.bbox || feature.bbox;
                if (featureBbox) {
                  if (
                    ['Point', 'MultiPoint'].includes(
                      featuresInfo[layerNames[layerName]].layer.dataType
                    )
                  )
                    featureProperties.bbox = L.latLng([
                      featureBbox[1],
                      featureBbox[0],
                    ]);
                  else
                    featureProperties.bbox = L.latLngBounds(
                      [featureBbox[1], featureBbox[0]],
                      [featureBbox[3], featureBbox[2]]
                    );
                }

                if (featuresInfo[layerNames[layerName]].featureInfo) {
                  featuresInfo[layerNames[layerName]].featureInfo.push(
                    featureProperties
                  );
                } else
                  featuresInfo[layerNames[layerName]].featureInfo = [
                    featureProperties,
                  ];
              }
            });
          }
        });
        return Object.keys(featuresInfo).map((k) => featuresInfo[k]);
      });
    }
    return [];
  };

  const getFromGeoJson = useCallback(
    (vectorLayers,latlng, layerPoint) => {
      let newFoundData = [];
      if (vectorLayers.length > 0) {
        // Realiza buffer na area clicada para garantir a seleção
        const bufferedMarker = turf.buffer(
          turf.point([latlng.lng, latlng.lat]),
          0.01,
          { units: 'meters' }
        );
        let bufferBbox = turf.bbox(bufferedMarker);
        bufferBbox = turf.bboxPolygon(bufferBbox);

        let bBox = turf.bbox(turf.point([latlng.lng, latlng.lat]));
        bBox = turf.bboxPolygon(bBox);

        vectorLayers.forEach((vl) => {
          let layerData = {
            layer: vl,
            featureInfo: [],
          };

          vl.leafletLayer.eachLayer((feature) => {
            let featureBbox = feature.getBounds && feature.getBounds();
            featureBbox = featureBbox && [
              featureBbox.getSouthWest().lng,
              featureBbox.getSouthWest().lat,
              featureBbox.getNorthEast().lng,
              featureBbox.getNorthEast().lat,
            ];
            if (
              turf.booleanIntersects(
                bBox,
                featureBbox ? turf.bboxPolygon(featureBbox) : feature.feature
              )
            ) {
              turf.booleanIntersects(feature.feature, bufferBbox) &&
                layerData.featureInfo.push({
                  ...feature.feature.properties,
                  bbox: feature.getBounds
                    ? feature.getBounds()
                    : feature.getLatLng(),
                });
            }
          });

          newFoundData.push(layerData);
        });
      }
      return newFoundData;
    },
    []
  );
  
  const getFeatureInfo = useCallback(
    async () => {      
      if (!searchingData) {
        let wmsLayers = [];
        let vectorLayers = [];
        let xPx, yPx, latLng;
        let positionMarker;
        let mapSize = map.getSize(); // para pegar o tamanho do mapa em pixels (x,y)        

        setSearchingData(true);

        if (window.innerWidth <= 768) {
          xPx = Math.floor(mapSize.x / 2);
          yPx = Math.floor(mapSize.y / 2);
          latLng = map.containerPointToLatLng([xPx, yPx]);
        } else {
          latLng = {lat:x, lng:y};
          positionMarker = map.latLngToLayerPoint(latLng);
          // xPx = Math.floor(positionMarker.x);
          // yPx = Math.floor(positionMarker.y);
          xPx = Math.floor(mapSize.x / 2);
          yPx = Math.floor(mapSize.y / 2);
        }
        let electivesLayers = layers.filter((l) => l.isSelected);
        electivesLayers =
          electivesLayers.length > 0
            ? electivesLayers.filter((l) => l.visible)
            : layers.filter((l) => l.visible);

        electivesLayers.forEach((l) => {
          let bounds = l.getBoundingBox();
          bounds = bounds
            ? L.latLngBounds(
                [bounds.miny, bounds.minx],
                [bounds.maxy, bounds.maxx]
              )
            : map.getBounds();
          if (bounds.contains(latLng)) {
            if (l.getService() === 'WMS') {
              let baseUrl = l.getServiceLink();
              let added = false;
              wmsLayers.forEach((v) => {
                if (
                  !added &&
                  !v.raster &&
                  l.dataType?.toUpperCase() !== 'RASTER'
                ) {
                  if (
                    v.baseUrl === baseUrl &&
                    !v.layers[l.getLayerNameParam()]
                  ) {
                    v.layers[l.getLayerNameParam()] = { layer: l };
                    added = true;
                  } else if (
                    v.baseUrl === baseUrl &&
                    v.layers[l.getLayerNameParam()]
                  ) {
                    added = true;
                  }
                }
              });
              if (!added)
                wmsLayers.push({
                  baseUrl,
                  layers: { [l.getLayerNameParam()]: { layer: l } },
                  raster: l.dataType?.toUpperCase() === 'RASTER',
                });
            } else if (
              l.getService() === 'WFS' ||
              l.type === 'importada' ||
              l.type === 'criada'
            ) {
              vectorLayers.push(l);
            }
          }
        });
        let dataFromGeoJson = getFromGeoJson(
          vectorLayers,
          latLng,
          positionMarker
        );
        // Realiza um buffer na coordenada para conseguir obter um bound box
        let bufferedMarker = turf.buffer(
          turf.point([latLng.lng, latLng.lat]),
          0.01,
          { units: 'meters' }
        );
        let bboxBufferBbox = turf.bbox(bufferedMarker);
        bboxBufferBbox = turf.bboxPolygon(bboxBufferBbox);        
        let dataFromWms = await getFromWms(
          wmsLayers,
          xPx,
          yPx,
          mapSize,
          bboxBufferBbox.bbox.toString()
        );
        setFoundData([...dataFromGeoJson, ...dataFromWms]);
        setAddCursor(true);
        setOpenTable(true);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ searchingData, x, y, map, layers ]
  );

  const defineCursor = useCallback(
    (preset = 'auto') => {
      if (preset !== 'auto') {
        const cursors = {
          blue: PinkMarker,
          orange: OrangeMarker,
        };
        setCursor(cursors[preset]);
      } else {
        let haveData = false;
        foundData &&
          foundData.forEach((v) => {
            if (v.featureInfo && v.featureInfo.length > 0) haveData = true;
          });
        setCursor(
          foundData !== null
            ? haveData
              ? PinkMarker
              : OrangeMarker
            : OrangeMarker
        );
      }
    },
    [foundData]
  );

  useEffect(() => {
    if (isActive) {
      defineCursor();
    }
  }, [defineCursor, isActive]);

  useEffect(() => {
    if (isActive) {
      if (!showModal) {
        setShowModal(false);
      }
    } else {
      setShowModal(false);
      //reomver marcador do mapa
      if (map) {
        map.eachLayer((layer) => {
          if (layer.options.icon) {
            map.removeLayer(layer);
          }
        });
      }
      // fechar tabela de atributos
      setBottomPanelIsOpen(false);
    }
  }, [isActive, map, setBottomPanelIsOpen, showModal]);

  //chama função para obter informação de camadas interseccionadas
  useEffect(() => {
    if ( latlngMarker && isActive && showModal && limitAllowed) {
      getFeatureInfo();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ isActive, latlngMarker, limitAllowed, showModal]);


  //abre a tabela de atributos e insere marcador no mapa.
  useEffect(() => {
    if (foundData && isActive && showModal && openTable) {
      setBottomPanelIsOpen(
        true,
        'Identificar Feição',
        <AttributeTable
          dataTabs={foundData}
          map={map}
          changeCursor={defineCursor}
        />
      );
      setLoadingInMap(false);
    } else {
      setBottomPanelIsOpen(false);
      setSearchingData(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [foundData, map, isActive, showModal, openTable]);

  useEffect(() => {
    let marker;
    if (latlngMarker && isActive && addCursor) {      
      var myIcon = L.icon({
        iconUrl: cursor,
        iconSize: [27, 33],
        iconAnchor: [13, 28],
        popupAnchor: [-3, -76],
      });
      marker = L.marker(latlngMarker, { icon: myIcon }).addTo(map);
      setOpenTable(true);
    }
    return () => marker && marker.remove();
  }, [latlngMarker, map, isActive, cursor, addCursor]);


  return (
    <>
      <ButtonTooltip
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: 'none',
          width: '35px',
          height: '40px',
        }}
        tooltip={IdentifyFeatureLocation.properties.alias}
        description={IdentifyFeatureLocation.properties.description}
        activeWithBgColor
        onClick={() => {
          if(!getCookie(
            configInformationalMessage.aliasModule,
            configInformationalMessage.toolId,
            configInformationalMessage.aliasIdentifierCookie) && !isActive){
            ReactDOM.render(
              <AlertConfirm
                title='Localização'
                message='A precisão da coordenada pode sofrer variações da sua localização atual.'
                callback={()=>{
                  setShowModal(!showModal)
                  setIsActive(!isActive);
                  if(!isActive){
                    getLocation();
                    setLoadingInMap(true);
                  }else{
                    handleDisableTool();
                  }
                }
                }
                buttonText='Ok'
                configInformationalMessage={configInformationalMessage}
              />,
              document.getElementById('alert')
            )
          }else{
            setShowModal(!showModal)
            setIsActive(!isActive);
            if(!isActive){
              getLocation();
              setLoadingInMap(true);
            }else{
              handleDisableTool();
            }
          }
        }}
        active={isActive}
      >
        <Icon width="24" height="24" />
      </ButtonTooltip>

      {isActive && showModal && limitAllowed === true &&(
        <CustomDraggable classeName=".input-text">
          <ModalContainer style={{ zIndex: 1700 }}>
            <div className="modal-int">
              <div className="wrap-title"  style={{
                cursor: 'move',
              }}>
                <span>Identificar Feição por Localização</span>
                <div
                  className="close-modal"
                  onClick={() => {
                    setShowModal(false);
                    handleDisableTool();
                  }}
                >
                  <IconClose width="24" height="24" />
                </div>
              </div>
              <div className="form-group">
                <div className='coordinatesCreated'>
                  <div className='inputCoordinates'>
                    <label>Latitude</label>
                    <div className='coordValue'>
                      <span>{x}</span>
                    </div>
                  </div>
                  <div className='inputCoordinates'>
                    <label>Longitude</label>
                    <div className='coordValue'>
                      <span>{y}</span>
                    </div>
                  </div>
                </div>

                <Groupbutton>
                  <div />
                  <div className="wrap-buttons">
                    <button
                      disabled={x && y ? false : true}
                      onClick={() => {
                        handleDisableTool();
                        setShowModal(false);
                      }}
                    >
                      <IconRemove width="24" height="24" />
                    </button>
                    <button
                      disabled={x && y ? false : true}
                      onClick={() => {
                        setSaveModalOpen(true);
                        setShowModal(false);
                      }}
                    >
                      <IconSave width="24" height="24" />
                    </button>
                  </div>
                </Groupbutton>
              </div>
            </div>
          </ModalContainer>
        </CustomDraggable>
      )}
      {showModal && limitAllowed === false &&(
        Notice({
          title: "Localização",
          message: "A ferramenta não pode ser ativada, pois sua localização encontra-se fora dos limites do estado da Bahia.",
          callback: (confirmed) => {
            handleDisableTool();
          },
        })
      )}
      {showModal && err === 'User denied Geolocation' &&(
        Notice({
          title: "Localização",
          message: "O acesso a sua localização está bloqueada. Para permitir, altere as configurações no seu browser.",
          callback: (confirmed) => {
            handleDisableTool();
          },
        })
      )}
      {showModal && latlngMarker === null && err !== 'User denied Geolocation' && err !== null &&(
        Notice({
          title: "Localização",
          message: "Não foi possível obter a sua localização, tente novamente mais tarde.",
          callback: (confirmed) => {
            handleDisableTool();
          },
        })
      )}


<CustomModalSaveAsLayer
        title="Salvar Camada"
        saveModalOpen={saveModalOpen}
        handleCloseSaveModal={handleCloseSaveModal}
        formik={formik}
        SliderColorPicker={ <SliderColorPicker
          geometryType="Point"
          autoSelect={false}
          selectedSymbology={formik.values.layerStyle}
          onSelect={(style) => formik.setFieldValue('layerStyle', style)}
        />}
      />

    </>
  );
};

IdentifyFeatureLocation.properties = {
  id: 'CPN-TB-A-IDENTIFY-FEATURE-LOCATION',
  alias: 'Identificar feição por localização',
  description:
    'Realiza a identificação de feições através de sua localização atual.',
};

export default IdentifyFeatureLocation;
